export default __webpack_public_path__ + "static/media/currentlocation.80e86a32.svg";